<template>
  <div id="modalTaxa" class="modal-zonas" v-show="opened">
    <div class="modal-zonas-content modal-rounded-scroll">
      <div class="py-4 py-md-3 bg-white shadow-sm">
        <div class="container text-center position-relative">
          <a href="javascript:" @click="closeModal" class="btn btn-outline-light btn-voltar-round position-absolute" style="left: 12px; top: -9px" aria-label="Voltar">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <h1 class="h6 font-weight-bold m-auto">Áreas de Entrega</h1>
        </div>
      </div>
      <div class="container-fluid mt-3 mb-4">
        <input type="search" class="form-control mb-3" id="termZona" v-model="term" @keyup="pesquisarZonas" placeholder="Pesquisar"
               @keyup.down="$helpers.focusrElement('zona0')">
        <div>
          <aviso-informativo variante="amarelo" class="mb-3">
            <div class="small">Selecione corretamente sua área de entrega ou seu pedido poderá ser cancelado.</div>
          </aviso-informativo>
          <a href="javascript:" tabindex="0" class="card card-zona text-dark"
             :class="{'border-primary': sacola.id_zona === z.id_zona}"
             v-for="(z, index) in search" :id="`zona${index}`" @click="selecionarZona(z)"
             @keyup.enter.prevent="selecionarZona(z)"
             @keyup.down="$helpers.focusrElement('zona' + (index + 1))"
             @keyup.up="index > 0 ? $helpers.focusrElement('zona' + (index - 1)) : $helpers.focusrElement('termZona')">
            <div class="zona-item">
              <icon name="address" class="text-primary mr-2" size="18"></icon>
              <div>
                <b>{{z.nome_zona}}</b>
                <div class="small" v-if="z.tempo_entrega > 40">
                  {{z.tempo_entrega | tempo}}
                </div>
              </div>
              <indicador-selecao class="ml-auto" :selecionado="sacola.id_zona === z.id_zona"/>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CardInfo from './CardInfo'
  import Loading from "./Loading";
  import Icon from "./Icon";
  import ModalMenu from "./ModalMenu";
  import IndicadorSelecao from "./IndicadorSelecao";
  import AvisoInformativo from "./AvisoInformativo";

  export default {
    name: "ZonasEntregas",
    components: {AvisoInformativo, IndicadorSelecao, ModalMenu, Icon, Loading, CardInfo},
    props: ['sacola'],
    data() {
      return {
        token: localStorage.getItem('token'),
        opened: false,
        avancar: false,
        term: '',
        search: [],
        dados: {}
      }
    },

    methods: {
      closeModal() {
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      abrirModal(avancar) {
        document.body.classList.add("modal-open");
        this.avancar = !!avancar;
        this.search = this.zonas;
        this.term = '';
        this.opened = true;

        this.$nextTick(() => {
          this.$helpers.focusrElement('termZona');
        })
      },

      selecionarZona(zona) {
        this.$emit('addZona', zona, this.avancar);
        this.closeModal();
      },

      pesquisarZonas() {
        if (this.term.trim().length) {
          this.search = this.zonas.filter(z => z.texto.includes(this.term.toLowerCase()) || z.nome_zona.toLowerCase().includes(this.term.toLowerCase()));

        } else {
          this.search = this.zonas;
        }
      },
    },

    computed: {
      zonas() {
        return [...(this.$store.state.empresa.zonas || [])].sort((a, b) => {
          const ordemA = parseInt(a.ordem, 10);
          const ordemB = parseInt(b.ordem, 10);
          const posicaoA = ordemA > 0 ? ordemA : Number.MAX_SAFE_INTEGER;
          const posicaoB = ordemB > 0 ? ordemB : Number.MAX_SAFE_INTEGER;

          return posicaoA - posicaoB || parseInt(a.id_zona, 10) - parseInt(b.id_zona, 10);
        })
      }
    },
  }
</script>

<style scoped>
  .modal-zonas {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-zonas-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 500px;
    height: 75vh;
    position: relative;
    border-radius: 12px;
  }

  .card-zona {
    margin-bottom: 8px;
    border: 1px solid #e3e6e9;
    box-shadow: none;
  }

  .zona-item {
    display: flex;
    align-items: center;
    min-height: 71px;
    padding: 14px;
  }

  .card-zona:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 600px) {
    .modal-zonas-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
      clip-path: none;
    }
  }
</style>
